module.exports = __webpack_public_path__ + "static/media/editIcon.8b34dea4.svg";